module.exports = __webpack_public_path__ + "files/b68d3cda724bff6b9898234782fac6e8.png";